export default {
    // Office types
    'OFFICE_TYPE_TOGGLE': 			'OFFICE_TYPE_TOGGLE',

    // Location list
    'LOCATIONS_GET':				'LOCATIONS_GET',
    'LOCATIONS_GET_RESPONSE':		'LOCATIONS_GET_RESPONSE',
    'LOCATIONS_SELECTED_SET':		'LOCATIONS_SELECTED_SET',

    // Geometry
    'GEOMETRY_SET':					'GEOMETRY_SET'
};